module.exports = __webpack_public_path__ + "static/media/phoneIcon.17cf6a52.svg";